import React from 'react';
import { observer } from 'mobx-react-lite';
import { Tooltip } from 'react-bootstrap';
import { getRegisteredMotionUIStore } from '../motion-ui-store';

/** Εμφάνιση field tooltips — ξεκινά από env και μπορεί να ανοίξει δυναμικά από το devMode. */
export const isFieldTooltipEnabled =
  process.env.VITE_APP_SHOW_FIELD_TOOLTIP === 'true' || process.env.REACT_APP_SHOW_FIELD_TOOLTIP === 'true';

type Props = {
  readonly text: string;
  readonly value: any;
  readonly alwaysShow?: boolean;
  readonly valueOnly?: boolean;
  /** Passed by react-bootstrap Overlay (show, placement, etc.) */
  readonly show?: boolean;
  readonly style?: React.CSSProperties;
} & Record<string, unknown>;

/** forwardRef so OverlayTrigger positions the tooltip correctly (ref on Tooltip root). */
const FieldTooltip = observer(
  React.forwardRef<HTMLDivElement, Props>(
    (
      { text, value, alwaysShow = false, valueOnly = false, show: overlayShow, style: overlayStyle, ...rest },
      ref,
    ) => {
      const motionUIStore = getRegisteredMotionUIStore();
      // Επιτρέπει άμεσο άνοιγμα των tooltips όταν ενεργοποιείται το dev mode χωρίς reload.
      const tooltipEnabled = isFieldTooltipEnabled || !!motionUIStore?.showFieldTooltip;

      const whiteTooltipStyle = {
        '--bs-tooltip-bg': '#ffffff',
        '--bs-tooltip-color': '#212529',
        '--bs-tooltip-opacity': '1',
      } as React.CSSProperties;
      const mergedStyle = Object.assign({}, overlayStyle as React.CSSProperties, whiteTooltipStyle);

      if (!alwaysShow && tooltipEnabled === false) return <></>;
      else
        return (
          <Tooltip
            ref={ref}
            id={`overlay-${text}`}
            style={mergedStyle}
            {...rest}
            show={!!overlayShow}
          >
            {valueOnly ? String(value) : `${String(text)}: ${String(value)}`}
          </Tooltip>
        );
    },
  ),
);

FieldTooltip.displayName = 'FieldTooltip';

export default FieldTooltip;
